import { names } from 'utilities/constants';

const locationConstants = names(
    'CLEAR',
    'LOCATION_CHANGED',
    'DIVISION_CHANGED',
    'PROJECT_CHANGED',
    'SITE_CHANGED',
    'ZONE_CHANGED');

export default locationConstants;